import React from 'react';

const ThemePickerModal = ({ darkMode, themes, currentTheme, onSelectTheme, onClose }) => {
  // Theme display names
  const themeNames = {
    blue: 'Sky',
    meadow: 'Meadow',
    amber: 'Amber',
    forest: 'Forest',
    hazelnut: 'Hazelnut',
    sunset: 'Sunset',
    ocean: 'Ocean'
  };

  return (
    <div className="fixed inset-0 z-50 md:flex md:items-center md:justify-center md:p-4 bg-black bg-opacity-50" onClick={onClose}>
      <div
        className={darkMode
          ? 'h-full md:h-auto bg-slate-900 md:rounded-2xl p-6 md:max-w-2xl w-full shadow-2xl md:border border-slate-700'
          : 'h-full md:h-auto bg-white md:rounded-2xl p-6 md:max-w-2xl w-full shadow-2xl'
        }
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-bold">Choose Theme</h3>
          <button
            onClick={onClose}
            className={darkMode ? 'text-slate-400 hover:text-white text-2xl leading-none w-8 h-8' : 'text-slate-600 hover:text-slate-900 text-2xl leading-none w-8 h-8'}
          >
            ×
          </button>
        </div>

        <div className="grid grid-cols-2 gap-3 pb-6">
          {Object.keys(themes).map((themeKey) => {
            const theme = themes[themeKey];
            const isSelected = currentTheme === themeKey;

            return (
              <button
                key={themeKey}
                onClick={() => {
                  onSelectTheme(themeKey);
                  onClose();
                }}
                className={
                  darkMode
                    ? `flex flex-col items-center gap-3 p-4 rounded-xl border transition-all ${
                        isSelected
                          ? 'border-slate-400 bg-slate-800 ring-2 ring-slate-400'
                          : 'border-slate-700 bg-slate-800 hover:border-slate-500'
                      }`
                    : `flex flex-col items-center gap-3 p-4 rounded-xl border transition-all ${
                        isSelected
                          ? 'border-slate-400 bg-slate-50 ring-2 ring-slate-300'
                          : 'border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50'
                      }`
                }
              >
                {/* Color swatch with gradient */}
                <div className={`w-20 h-20 rounded-xl bg-gradient-to-br ${theme.grad} shadow-md relative`}>
                  {isSelected && (
                    <div className="absolute -top-1 -right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center text-sm shadow-lg">
                      ✓
                    </div>
                  )}
                </div>

                {/* Theme name */}
                <div className="text-center">
                  <div className="font-semibold">
                    {themeNames[themeKey] || themeKey}
                  </div>
                  {isSelected && (
                    <div className={darkMode ? 'text-xs text-slate-400 mt-0.5' : 'text-xs text-slate-500 mt-0.5'}>
                      Current
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ThemePickerModal;
